import { AnyProfile } from '@/utils/profileHelpers';

export enum ChatSwitchTabs {
  PEOPLE = 'people',
  MESSAGES = 'messages',
}

export type ChatProfile = AnyProfile & { user?: { id: string } };
